import { gql } from '@apollo/client'
export const EXPORT_FEEDBACKS_QUERY = gql`
  query exportFeedbacks(
    $format: FeedbackExportTypeEnum
    $filter: FeedbackFilter
    $sortBy: FeedbackSort
    $ids: [ID!]
    $columns: [FeedbackExportColumn!]
  ) {
    exportFeedbacks(format: $format, filter: $filter, sortBy: $sortBy, ids: $ids, columns: $columns)
  }
`
